import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2A5A98F5-ED95-40DE-8EC5-1293795CF661
 * name shield-home
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-home.svg
 * tags
 * - Home Automation 
 */
export const ShieldHomeIcon = createSvgIcon(<><path d="M11,13H13V16H16V11H18L12,6L6,11H8V16H11V13M12,1L21,5V11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1Z" /></>, 'ShieldHomeIcon');
export default ShieldHomeIcon